import { render, staticRenderFns } from "./OrganizationEdit.vue?vue&type=template&id=1413a29c&"
import script from "./OrganizationEdit.vue?vue&type=script&lang=js&"
export * from "./OrganizationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports